import { Component } from '@angular/core';
import { NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { NavigationEnd } from '@angular/router'
import { Mask, MaskService } from './services/mask/mask.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';

  constructor(private router: Router, private _maskService: MaskService) {
    this.router.events.subscribe(event => {
      /*if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }*/

      if (event instanceof NavigationStart) {
        if (event.url == '/' || event.url == '/login') {
          this._maskService.setMask(Mask.basicMask, true);
        }
      }
    })
  }
}
